/* eslint-disable react-refresh/only-export-components */
// 组件 + variants(badgeVariants)同文件为 shadcn/ui 有意模式;react-refresh 仅关注 HMR。
import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/lib/utils";

// 配色走皮肤 token,3 套皮肤都正确区分;cyber 的霓虹渐变由 skin-cyber.css `.cyber-badge.*` 还原。
const badgeVariants = cva(
  [
    "cyber-badge inline-flex items-center rounded-full border px-2.5 py-0.5 text-2xs font-semibold uppercase tracking-[0.08em]",
    "transition-all duration-200",
    "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  ].join(" "),
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "border-border text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

// 2026-05-25 F-25 修复:Radix `<Slot>` 包 Badge 时需要 forwardRef,否则全工程
// 红字 "Function components cannot be given refs. ... at Badge ... SlotClone"
const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
